'use strict';

var _toConsumableArray = require("/shared/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/shared/node_modules/@babel/runtime/helpers/slicedToArray");

var arrayMoveMutate = function arrayMoveMutate(array, from, to) {
  var startIndex = from < 0 ? array.length + from : from;

  if (startIndex >= 0 && startIndex < array.length) {
    var endIndex = to < 0 ? array.length + to : to;

    var _array$splice = array.splice(from, 1),
        _array$splice2 = _slicedToArray(_array$splice, 1),
        item = _array$splice2[0];

    array.splice(endIndex, 0, item);
  }
};

var arrayMove = function arrayMove(array, from, to) {
  array = _toConsumableArray(array);
  arrayMoveMutate(array, from, to);
  return array;
};

module.exports = arrayMove;
module.exports.mutate = arrayMoveMutate;